import { render } from "./InstructionsView.vue?vue&type=template&id=e044aafe"
import script from "./InstructionsView.vue?vue&type=script&lang=js"
export * from "./InstructionsView.vue?vue&type=script&lang=js"

import "./InstructionsView.vue?vue&type=style&index=0&id=e044aafe&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__